@if (isLoading) {
  <div class="loader-block">
    <mat-spinner></mat-spinner>
  </div>
} @else if (isNoData) {
  <div>
    <p class="text-center">No data</p>
  </div>
}
